module.exports = __webpack_public_path__ + "starphone.svg?0b7c2f7401001cfdf420ab9f35129688";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/starphone.svg
// module id = 90
// module chunks = 0